export default __webpack_public_path__ + "static/media/Entreprise.bf97a184.jpg";